import { ItemType } from './types';

// 商店物品价格配置 (钻石)
interface ShopItemPrice {
  itemType: ItemType;
  price: number;
}

// 定义每种道具对应的钻石价格
export const SHOP_ITEMS_PRICE: ShopItemPrice[] = [
  {
    itemType: ItemType.RESET,
    price: 2 // 重置器: 2钻石
  },
  {
    itemType: ItemType.SWAP,
    price: 5 // 交换器: 5钻石
  },
  {
    itemType: ItemType.UPGRADE,
    price: 3 // 升级器: 3钻石
  },
  {
    itemType: ItemType.RECOVER,
    price: 6 // 恢复剂: 6钻石
  },
  {
    itemType: ItemType.REVIVE,
    price: 10 // 复活卡: 10钻石
  }
];

// 初始钻石数量
export const INITIAL_DIAMONDS = 20;

// 根据道具类型获取价格
export const getItemPrice = (itemType: ItemType): number => {
  const item = SHOP_ITEMS_PRICE.find(item => item.itemType === itemType);
  return item ? item.price : 0;
};

// 计算购物车总价
export const calculateTotalPrice = (cart: Map<ItemType, number>): number => {
  let total = 0;
  
  cart.forEach((quantity, itemType) => {
    const price = getItemPrice(itemType);
    total += price * quantity;
  });
  
  return total;
}; 